let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cOIYm")).then(() => parcelRequire('8K7FM'));